module.exports = __webpack_public_path__ + "img/bow tie collar width.14470077.png";